
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M10.356 2.394c.46.124.868.35 1.21.65 1.023-.04 2.039.822 2.379 2.094.245.919.08 1.828-.372 2.443.185.241.253.62.15 1.004-.086.322-.273.58-.497.724-.122.912-.616 1.696-1.317 2.205-.046.033-.098.064-.157.093.464 1.395 1.579 2.494 3.007 2.923l.689.207c1.192.358 2.017 1.442 2.05 2.684l.002.079h-15c0-1.274.834-2.397 2.052-2.763l.689-.207c1.428-.43 2.543-1.528 3.007-2.923-.059-.029-.111-.06-.157-.093-.701-.509-1.195-1.293-1.317-2.205-.224-.143-.41-.402-.497-.724-.125-.469.002-.928.289-1.142-.353-.739-.452-1.628-.216-2.513.498-1.86 2.292-2.996 4.006-2.536z"}})])
          )
        }
      }
    